export enum USER_PERMISSIONS {
  // --- EXISTING PERMISSIONS ---
  ACCOUNT_ADD_EMAILADDRESS = 'account.add_emailaddress',
  ACCOUNT_ADD_EMAILCONFIRMATION = 'account.add_emailconfirmation',
  ACCOUNT_CHANGE_EMAILADDRESS = 'account.change_emailaddress',
  ACCOUNT_CHANGE_EMAILCONFIRMATION = 'account.change_emailconfirmation',
  ACCOUNT_DELETE_EMAILADDRESS = 'account.delete_emailaddress',
  ACCOUNT_DELETE_EMAILCONFIRMATION = 'account.delete_emailconfirmation',
  ACCOUNT_VIEW_EMAILADDRESS = 'account.view_emailaddress',
  ACCOUNT_VIEW_EMAILCONFIRMATION = 'account.view_emailconfirmation',
  ADMIN_ADD_LOGENTRY = 'admin.add_logentry',
  ADMIN_CHANGE_LOGENTRY = 'admin.change_logentry',
  ADMIN_DELETE_LOGENTRY = 'admin.delete_logentry',
  ADMIN_VIEW_LOGENTRY = 'admin.view_logentry',
  AUTH_ADD_GROUP = 'auth.add_group',
  AUTH_ADD_PERMISSION = 'auth.add_permission',
  AUTH_CHANGE_GROUP = 'auth.change_group',
  AUTH_CHANGE_PERMISSION = 'auth.change_permission',
  AUTH_DELETE_GROUP = 'auth.delete_group',
  AUTH_DELETE_PERMISSION = 'auth.delete_permission',
  AUTH_VIEW_GROUP = 'auth.view_group',
  AUTH_VIEW_PERMISSION = 'auth.view_permission',

  // --- MISSING CONTENT TYPES ---
  CONTENTTYPES_ADD_CONTENTTYPE = 'contenttypes.add_contenttype',
  CONTENTTYPES_CHANGE_CONTENTTYPE = 'contenttypes.change_contenttype',
  CONTENTTYPES_DELETE_CONTENTTYPE = 'contenttypes.delete_contenttype',
  CONTENTTYPES_VIEW_CONTENTTYPE = 'contenttypes.view_contenttype',

  // --- SOCIAL ACCOUNT (ALLAUTH) ---
  SOCIALACCOUNT_ADD_SOCIALACCOUNT = 'socialaccount.add_socialaccount',
  SOCIALACCOUNT_CHANGE_SOCIALACCOUNT = 'socialaccount.change_socialaccount',
  SOCIALACCOUNT_DELETE_SOCIALACCOUNT = 'socialaccount.delete_socialaccount',
  SOCIALACCOUNT_VIEW_SOCIALACCOUNT = 'socialaccount.view_socialaccount',
  SOCIALACCOUNT_ADD_SOCIALAPP = 'socialaccount.add_socialapp',
  SOCIALACCOUNT_CHANGE_SOCIALAPP = 'socialaccount.change_socialapp',
  SOCIALACCOUNT_DELETE_SOCIALAPP = 'socialaccount.delete_socialapp',
  SOCIALACCOUNT_VIEW_SOCIALAPP = 'socialaccount.view_socialapp',
  SOCIALACCOUNT_ADD_SOCIALTOKEN = 'socialaccount.add_socialtoken',
  SOCIALACCOUNT_CHANGE_SOCIALTOKEN = 'socialaccount.change_socialtoken',
  SOCIALACCOUNT_DELETE_SOCIALTOKEN = 'socialaccount.delete_socialtoken',
  SOCIALACCOUNT_VIEW_SOCIALTOKEN = 'socialaccount.view_socialtoken',

  // --- OTP / 2FA DEVICES ---
  OTP_STATIC_ADD_STATICDEVICE = 'otp_static.add_staticdevice',
  OTP_STATIC_CHANGE_STATICDEVICE = 'otp_static.change_staticdevice',
  OTP_STATIC_DELETE_STATICDEVICE = 'otp_static.delete_staticdevice',
  OTP_STATIC_VIEW_STATICDEVICE = 'otp_static.view_staticdevice',
  OTP_STATIC_ADD_STATICTOKEN = 'otp_static.add_statictoken',
  OTP_STATIC_CHANGE_STATICTOKEN = 'otp_static.change_statictoken',
  OTP_STATIC_DELETE_STATICTOKEN = 'otp_static.delete_statictoken',
  OTP_STATIC_VIEW_STATICTOKEN = 'otp_static.view_statictoken',
  OTP_TOTP_ADD_TOTPDEVICE = 'otp_totp.add_totpdevice',
  OTP_TOTP_CHANGE_TOTPDEVICE = 'otp_totp.change_totpdevice',
  OTP_TOTP_DELETE_TOTPDEVICE = 'otp_totp.delete_totpdevice',
  OTP_TOTP_VIEW_TOTPDEVICE = 'otp_totp.view_totpdevice',

  // --- EXISTING CLINIC PERMISSIONS ---
  CLINIC_ADD_APPOINTMENT = 'clinic.add_appointment',
  CLINIC_ADD_APPOINTMENTCATEGORY = 'clinic.add_appointmentcategory',
  CLINIC_ADD_APPOINTMENTOUTCOME = 'clinic.add_appointmentoutcome',
  CLINIC_ADD_APPOINTMENTTYPE = 'clinic.add_appointmenttype',
  CLINIC_ADD_APPOINTMENTTYPETAG = 'clinic.add_appointmenttypetag',
  CLINIC_ADD_AVAILABILITY = 'clinic.add_availability',
  CLINIC_ADD_COMPETENCY = 'clinic.add_competency',
  CLINIC_ADD_STAFF_COMPETENCY = 'clinic.add_staffcompetency',
  CLINIC_ADD_STAFF_SETTINGS = 'clinic.add_staffsettings',
  CLINIC_ADD_GPSURGERY = 'clinic.add_gpsurgery',
  CLINIC_ADD_OUTCOME = 'clinic.add_outcome',
  CLINIC_ADD_ROOM = 'clinic.add_room',
  CLINIC_ADD_SITE = 'clinic.add_site',
  CLINIC_ADD_STAFF = 'clinic.add_staff',
  CLINIC_ADD_SUPPLIEDTREATMENT = 'clinic.add_suppliedtreatment',
  CLINIC_ADD_TREATMENT = 'clinic.add_treatment',
  CLINIC_ADD_USER = 'clinic.add_user',
  CLINIC_ADD_ADVICE_CATEGORY = 'clinic.add_advicecategory',
  CLINIC_ADD_FIELD_IDENTIFIER = 'clinic.add_fieldidentifier',
  CLINIC_ADD_PATIENT_ADVICE = 'clinic.add_patientadvice',
  CLINIC_ADD_VACCINE_PRODUCT = 'clinic.add_vaccineproduct',
  CLINIC_ADD_VACCINATION_HISTORY = 'clinic.add_vaccinationhistory',
  CLINIC_ADD_ALLERGY = 'clinic.add_allergy',
  CLINIC_ADD_EQUIPMENT = 'clinic.add_equipment',
  CLINIC_ADD_INCIDENT_REPORT = 'clinic.add_incidentreport',
  CLINIC_ADD_IT_INCIDENT = 'clinic.add_itincident',
  CLINIC_ADD_CUSTOMER_COMPLAINT = 'clinic.add_customercomplaint',
  CLINIC_ADD_SAFETY_REPORT = 'clinic.add_safetyreport',
  CLINIC_CHANGE_APPOINTMENT = 'clinic.change_appointment',
  CLINIC_CHANGE_APPOINTMENTCATEGORY = 'clinic.change_appointmentcategory',
  CLINIC_CHANGE_APPOINTMENTOUTCOME = 'clinic.change_appointmentoutcome',
  CLINIC_CHANGE_APPOINTMENTTYPE = 'clinic.change_appointmenttype',
  CLINIC_CHANGE_APPOINTMENTTYPETAG = 'clinic.change_appointmenttypetag',
  CLINIC_CHANGE_AVAILABILITY = 'clinic.change_availability',
  CLINIC_CHANGE_COMPETENCY = 'clinic.change_competency',
  CLINIC_CHANGE_STAFF_COMPETENCY = 'clinic.change_staffcompetency',
  CLINIC_CHANGE_STAFF_SETTINGS = 'clinic.change_staffsettings',
  CLINIC_CHANGE_GPSURGERY = 'clinic.change_gpsurgery',
  CLINIC_CHANGE_OUTCOME = 'clinic.change_outcome',
  CLINIC_CHANGE_ROOM = 'clinic.change_room',
  CLINIC_CHANGE_SITE = 'clinic.change_site',
  CLINIC_CHANGE_STAFF = 'clinic.change_staff',
  CLINIC_CHANGE_SUPPLIEDTREATMENT = 'clinic.change_suppliedtreatment',
  CLINIC_CHANGE_TREATMENT = 'clinic.change_treatment',
  CLINIC_CHANGE_USER = 'clinic.change_user',
  CLINIC_CHANGE_ADVICE_CATEGORY = 'clinic.change_advicecategory',
  CLINIC_CHANGE_FIELD_IDENTIFIER = 'clinic.change_fieldidentifier',
  CLINIC_CHANGE_PATIENT_ADVICE = 'clinic.change_patientadvice',
  CLINIC_CHANGE_VACCINE_PRODUCT = 'clinic.change_vaccineproduct',
  CLINIC_CHANGE_VACCINATION_HISTORY = 'clinic.change_vaccinationhistory',
  CLINIC_CHANGE_ALLERGY = 'clinic.change_allergy',
  CLINIC_CHANGE_EQUIPMENT = 'clinic.change_equipment',
  CLINIC_CHANGE_INCIDENT_REPORT = 'clinic.change_incidentreport',
  CLINIC_CHANGE_IT_INCIDENT = 'clinic.change_itincident',
  CLINIC_CHANGE_CUSTOMER_COMPLAINT = 'clinic.change_customercomplaint',
  CLINIC_CHANGE_SAFETY_REPORT = 'clinic.change_safetyreport',
  CLINIC_CREATE_OTHER_AVAILABILITY = 'clinic.create_other_availability',
  CLINIC_CREATE_USER = 'clinic.create_user',
  CLINIC_DELETE_APPOINTMENT = 'clinic.delete_appointment',
  CLINIC_DELETE_APPOINTMENTCATEGORY = 'clinic.delete_appointmentcategory',
  CLINIC_DELETE_APPOINTMENTOUTCOME = 'clinic.delete_appointmentoutcome',
  CLINIC_DELETE_APPOINTMENTTYPE = 'clinic.delete_appointmenttype',
  CLINIC_DELETE_APPOINTMENTTYPETAG = 'clinic.delete_appointmenttypetag',
  CLINIC_DELETE_AVAILABILITY = 'clinic.delete_availability',
  CLINIC_DELETE_COMPETENCY = 'clinic.delete_competency',
  CLINIC_DELETE_STAFF_COMPETENCY = 'clinic.delete_staffcompetency',
  CLINIC_DELETE_STAFF_SETTINGS = 'clinic.delete_staffsettings',
  CLINIC_DELETE_GPSURGERY = 'clinic.delete_gpsurgery',
  CLINIC_DELETE_OTHER_AVAILABILITY = 'clinic.delete_other_availability',
  CLINIC_DELETE_OUTCOME = 'clinic.delete_outcome',
  CLINIC_DELETE_ROOM = 'clinic.delete_room',
  CLINIC_DELETE_SITE = 'clinic.delete_site',
  CLINIC_DELETE_STAFF = 'clinic.delete_staff',
  CLINIC_DELETE_SUPPLIEDTREATMENT = 'clinic.delete_suppliedtreatment',
  CLINIC_DELETE_TREATMENT = 'clinic.delete_treatment',
  CLINIC_DELETE_USER = 'clinic.delete_user',
  CLINIC_DELETE_ADVICE_CATEGORY = 'clinic.delete_advicecategory',
  CLINIC_DELETE_FIELD_IDENTIFIER = 'clinic.delete_fieldidentifier',
  CLINIC_DELETE_PATIENT_ADVICE = 'clinic.delete_patientadvice',
  CLINIC_DELETE_VACCINE_PRODUCT = 'clinic.delete_vaccineproduct',
  CLINIC_DELETE_VACCINATION_HISTORY = 'clinic.delete_vaccinationhistory',
  CLINIC_DELETE_ALLERGY = 'clinic.delete_allergy',
  CLINIC_DELETE_EQUIPMENT = 'clinic.delete_equipment',
  CLINIC_DELETE_INCIDENT_REPORT = 'clinic.delete_incidentreport',
  CLINIC_DELETE_IT_INCIDENT = 'clinic.delete_itincident',
  CLINIC_DELETE_CUSTOMER_COMPLAINT = 'clinic.delete_customercomplaint',
  CLINIC_DELETE_SAFETY_REPORT = 'clinic.delete_safetyreport',
  CLINIC_EDIT_OTHER_AVAILABILITY = 'clinic.edit_other_availability',
  CLINIC_OVERRIDE_APPOINTMENT_TYPES = 'clinic.override_appointment_types',
  CLINIC_OVERRIDE_APPOINTMENT_DURATION = 'clinic.override_appointment_duration',
  CLINIC_SELECT_ROOM = 'clinic.select_room',
  CLINIC_SELECT_USER = 'clinic.select_user',
  CLINIC_USER_ADMIN = 'clinic.user_admin',
  CLINIC_VIEW_APPOINTMENT = 'clinic.view_appointment',
  CLINIC_VIEW_APPOINTMENTCATEGORY = 'clinic.view_appointmentcategory',
  CLINIC_VIEW_APPOINTMENTOUTCOME = 'clinic.view_appointmentoutcome',
  CLINIC_VIEW_APPOINTMENTTYPE = 'clinic.view_appointmenttype',
  CLINIC_VIEW_APPOINTMENTTYPETAG = 'clinic.view_appointmenttypetag',
  CLINIC_VIEW_AVAILABILITY = 'clinic.view_availability',
  CLINIC_VIEW_COMPETENCY = 'clinic.view_competency',
  CLINIC_VIEW_STAFF_COMPETENCY = 'clinic.view_staffcompetency',
  CLINIC_VIEW_STAFF_SETTINGS = 'clinic.view_staffsettings',
  CLINIC_VIEW_GPSURGERY = 'clinic.view_gpsurgery',
  CLINIC_VIEW_HIDDEN_APPOINTMENT_TYPES = 'clinic.view_hidden_appointment_types',
  CLINIC_VIEW_HIDDEN_SITES = 'clinic.view_hidden_sites',
  CLINIC_DOWNLOAD_SITE_QR = 'clinic.download_site_qr',
  CLINIC_REGENERATE_SITE_QR = 'clinic.regenerate_site_qr',
  CLINIC_VIEW_HIDDEN_APPOINTMENT_CATEGORIES = 'clinic.view_hidden_appointment_categories',
  CLINIC_VIEW_OTHER_APPOINTMENTS = 'clinic.view_other_appointments',
  CLINIC_VIEW_OUTCOME = 'clinic.view_outcome',
  CLINIC_VIEW_ROOM = 'clinic.view_room',
  CLINIC_VIEW_SITE = 'clinic.view_site',
  CLINIC_VIEW_STAFF = 'clinic.view_staff',
  CLINIC_VIEW_SUPPLIEDTREATMENT = 'clinic.view_suppliedtreatment',
  CLINIC_VIEW_TREATMENT = 'clinic.view_treatment',
  CLINIC_VIEW_USER = 'clinic.view_user',
  CLINIC_VIEW_ADVICE_CATEGORY = 'clinic.view_advicecategory',
  CLINIC_VIEW_FIELD_IDENTIFIER = 'clinic.view_fieldidentifier',
  CLINIC_VIEW_PATIENT_ADVICE = 'clinic.view_patientadvice',
  CLINIC_VIEW_VACCINE_PRODUCT = 'clinic.view_vaccineproduct',
  CLINIC_VIEW_VACCINATION_HISTORY = 'clinic.view_vaccinationhistory',
  CLINIC_VIEW_ALLERGY = 'clinic.view_allergy',
  CLINIC_VIEW_INCIDENT_REPORT = 'clinic.view_incidentreport',
  CLINIC_VIEW_IT_INCIDENT = 'clinic.view_itincident',
  CLINIC_VIEW_CUSTOMER_COMPLAINT = 'clinic.view_customercomplaint',
  CLINIC_VIEW_SAFETY_REPORT = 'clinic.view_safetyreport',
  CLINIC_VIEW_RELEASE_NOTES = 'clinic.view_release_notes',
  CLINIC_VIEW_EQUIPMENT = 'clinic.view_equipment',
  CLINIC_VIEW_NEWS_FEED = 'clinic.view_newsindexpage',
  CLINIC_CAN_MANAGE_DUPLICATES = 'clinic.can_manage_duplicates',
  CLINIC_CAN_MANAGE_DUPLICATE_GUEST_USERS = 'clinic.can_manage_duplicate_guest_users',
  CLINIC_CAN_ACTION_SAFETY_REPORT = 'clinic.can_action_report',

  // --- EFORMS ---
  EFORMS_ADD_CLINICIANFORM = 'eforms.add_clinicianform',
  EFORMS_ADD_EFORM = 'eforms.add_eform',
  EFORMS_ADD_SAVEDFORM = 'eforms.add_savedform',
  EFORMS_ADD_SUBMITTEDFORM = 'eforms.add_submittedform',
  EFORMS_CHANGE_CLINICIANFORM = 'eforms.change_clinicianform',
  EFORMS_CHANGE_EFORM = 'eforms.change_eform',
  EFORMS_CHANGE_SAVEDFORM = 'eforms.change_savedform',
  EFORMS_CHANGE_SUBMITTEDFORM = 'eforms.change_submittedform',
  EFORMS_DELETE_CLINICIANFORM = 'eforms.delete_clinicianform',
  EFORMS_DELETE_EFORM = 'eforms.delete_eform',
  EFORMS_DELETE_SAVEDFORM = 'eforms.delete_savedform',
  EFORMS_DELETE_SUBMITTEDFORM = 'eforms.delete_submittedform',
  EFORMS_VIEW_CLINICIANFORM = 'eforms.view_clinicianform',
  EFORMS_VIEW_EFORM = 'eforms.view_eform',
  EFORMS_VIEW_OTHER_FORMS = 'eforms.view_other_forms',
  EFORMS_VIEW_SAVEDFORM = 'eforms.view_savedform',
  EFORMS_VIEW_SUBMITTEDFORM = 'eforms.view_submittedform',

  // --- EXISTING SESSIONS/SITES ---
  SESSIONS_ADD_SESSION = 'sessions.add_session',
  SESSIONS_CHANGE_SESSION = 'sessions.change_session',
  SESSIONS_DELETE_SESSION = 'sessions.delete_session',
  SESSIONS_VIEW_SESSION = 'sessions.view_session',
  SITES_ADD_SITE = 'sites.add_site',
  SITES_CHANGE_SITE = 'sites.change_site',
  SITES_DELETE_SITE = 'sites.delete_site',
  SITES_VIEW_SITE = 'sites.view_site',

  // --- WAGTAIL CORE / ADMIN ---
  WAGTAILADMIN_ACCESS_ADMIN = 'wagtailadmin.access_admin',
  WAGTAILCORE_ADD_PAGE = 'wagtailcore.add_page',
  WAGTAILCORE_CHANGE_PAGE = 'wagtailcore.change_page',
  WAGTAILCORE_DELETE_PAGE = 'wagtailcore.delete_page',
  WAGTAILCORE_VIEW_PAGE = 'wagtailcore.view_page',
  WAGTAILCORE_PUBLISH_PAGE = 'wagtailcore.publish_page',
  WAGTAILCORE_LOCK_PAGE = 'wagtailcore.lock_page',
  WAGTAILCORE_UNLOCK_PAGE = 'wagtailcore.unlock_page',
  WAGTAILCORE_BULK_DELETE_PAGE = 'wagtailcore.bulk_delete_page',
  WAGTAILCORE_ADD_SITE = 'wagtailcore.add_site',
  WAGTAILCORE_CHANGE_SITE = 'wagtailcore.change_site',
  WAGTAILCORE_DELETE_SITE = 'wagtailcore.delete_site',
  WAGTAILCORE_VIEW_SITE = 'wagtailcore.view_site',
  WAGTAILCORE_ADD_GROUPSITEPERMISSION = 'wagtailcore.add_groupsitepermission',
  WAGTAILCORE_CHANGE_GROUPSITEPERMISSION = 'wagtailcore.change_groupsitepermission',
  WAGTAILCORE_DELETE_GROUPSITEPERMISSION = 'wagtailcore.delete_groupsitepermission',
  WAGTAILCORE_VIEW_GROUPSITEPERMISSION = 'wagtailcore.view_groupsitepermission',
  WAGTAILCORE_ADD_MODELLOGENTRY = 'wagtailcore.add_modellogentry',
  WAGTAILCORE_CHANGE_MODELLOGENTRY = 'wagtailcore.change_modellogentry',
  WAGTAILCORE_DELETE_MODELLOGENTRY = 'wagtailcore.delete_modellogentry',
  WAGTAILCORE_VIEW_MODELLOGENTRY = 'wagtailcore.view_modellogentry',
  WAGTAILCORE_ADD_REVISION = 'wagtailcore.add_revision',
  WAGTAILCORE_CHANGE_REVISION = 'wagtailcore.change_revision',
  WAGTAILCORE_DELETE_REVISION = 'wagtailcore.delete_revision',
  WAGTAILCORE_VIEW_REVISION = 'wagtailcore.view_revision',
  WAGTAILCORE_ADD_COLLECTIONVIEWRESTRICTION = 'wagtailcore.add_collectionviewrestriction',
  WAGTAILCORE_CHANGE_COLLECTIONVIEWRESTRICTION = 'wagtailcore.change_collectionviewrestriction',
  WAGTAILCORE_DELETE_COLLECTIONVIEWRESTRICTION = 'wagtailcore.delete_collectionviewrestriction',
  WAGTAILCORE_VIEW_COLLECTIONVIEWRESTRICTION = 'wagtailcore.view_collectionviewrestriction',
  WAGTAILCORE_ADD_COLLECTION = 'wagtailcore.add_collection',
  WAGTAILCORE_CHANGE_COLLECTION = 'wagtailcore.change_collection',
  WAGTAILCORE_DELETE_COLLECTION = 'wagtailcore.delete_collection',
  WAGTAILCORE_VIEW_COLLECTION = 'wagtailcore.view_collection',
  WAGTAILCORE_ADD_GROUPCOLLECTIONPERMISSION = 'wagtailcore.add_groupcollectionpermission',
  WAGTAILCORE_CHANGE_GROUPCOLLECTIONPERMISSION = 'wagtailcore.change_groupcollectionpermission',
  WAGTAILCORE_DELETE_GROUPCOLLECTIONPERMISSION = 'wagtailcore.delete_groupcollectionpermission',
  WAGTAILCORE_VIEW_GROUPCOLLECTIONPERMISSION = 'wagtailcore.view_groupcollectionpermission',
  WAGTAILCORE_ADD_GROUPPAGEPERMISSION = 'wagtailcore.add_grouppagepermission',
  WAGTAILCORE_CHANGE_GROUPPAGEPERMISSION = 'wagtailcore.change_grouppagepermission',
  WAGTAILCORE_DELETE_GROUPPAGEPERMISSION = 'wagtailcore.delete_grouppagepermission',
  WAGTAILCORE_VIEW_GROUPPAGEPERMISSION = 'wagtailcore.view_grouppagepermission',
  WAGTAILCORE_ADD_PAGEVIEWRESTRICTION = 'wagtailcore.add_pageviewrestriction',
  WAGTAILCORE_CHANGE_PAGEVIEWRESTRICTION = 'wagtailcore.change_pageviewrestriction',
  WAGTAILCORE_DELETE_PAGEVIEWRESTRICTION = 'wagtailcore.delete_pageviewrestriction',
  WAGTAILCORE_VIEW_PAGEVIEWRESTRICTION = 'wagtailcore.view_pageviewrestriction',
  WAGTAILCORE_ADD_WORKFLOWPAGE = 'wagtailcore.add_workflowpage',
  WAGTAILCORE_CHANGE_WORKFLOWPAGE = 'wagtailcore.change_workflowpage',
  WAGTAILCORE_DELETE_WORKFLOWPAGE = 'wagtailcore.delete_workflowpage',
  WAGTAILCORE_VIEW_WORKFLOWPAGE = 'wagtailcore.view_workflowpage',
  WAGTAILCORE_ADD_PAGELOGENTRY = 'wagtailcore.add_pagelogentry',
  WAGTAILCORE_CHANGE_PAGELOGENTRY = 'wagtailcore.change_pagelogentry',
  WAGTAILCORE_DELETE_PAGELOGENTRY = 'wagtailcore.delete_pagelogentry',
  WAGTAILCORE_VIEW_PAGELOGENTRY = 'wagtailcore.view_pagelogentry',
  WAGTAILCORE_ADD_COMMENT = 'wagtailcore.add_comment',
  WAGTAILCORE_CHANGE_COMMENT = 'wagtailcore.change_comment',
  WAGTAILCORE_DELETE_COMMENT = 'wagtailcore.delete_comment',
  WAGTAILCORE_VIEW_COMMENT = 'wagtailcore.view_comment',
  WAGTAILCORE_ADD_COMMENTREPLY = 'wagtailcore.add_commentreply',
  WAGTAILCORE_CHANGE_COMMENTREPLY = 'wagtailcore.change_commentreply',
  WAGTAILCORE_DELETE_COMMENTREPLY = 'wagtailcore.delete_commentreply',
  WAGTAILCORE_VIEW_COMMENTREPLY = 'wagtailcore.view_commentreply',
  WAGTAILCORE_ADD_PAGESUBSCRIPTION = 'wagtailcore.add_pagesubscription',
  WAGTAILCORE_CHANGE_PAGESUBSCRIPTION = 'wagtailcore.change_pagesubscription',
  WAGTAILCORE_DELETE_PAGESUBSCRIPTION = 'wagtailcore.delete_pagesubscription',
  WAGTAILCORE_VIEW_PAGESUBSCRIPTION = 'wagtailcore.view_pagesubscription',
  WAGTAILCORE_ADD_REFERENCEINDEX = 'wagtailcore.add_referenceindex',
  WAGTAILCORE_CHANGE_REFERENCEINDEX = 'wagtailcore.change_referenceindex',
  WAGTAILCORE_DELETE_REFERENCEINDEX = 'wagtailcore.delete_referenceindex',
  WAGTAILCORE_VIEW_REFERENCEINDEX = 'wagtailcore.view_referenceindex',
  WAGTAILCORE_ADD_WORKFLOW = 'wagtailcore.add_workflow',
  WAGTAILCORE_CHANGE_WORKFLOW = 'wagtailcore.change_workflow',
  WAGTAILCORE_DELETE_WORKFLOW = 'wagtailcore.delete_workflow',
  WAGTAILCORE_VIEW_WORKFLOW = 'wagtailcore.view_workflow',
  WAGTAILCORE_ADD_WORKFLOWTASK = 'wagtailcore.add_workflowtask',
  WAGTAILCORE_CHANGE_WORKFLOWTASK = 'wagtailcore.change_workflowtask',
  WAGTAILCORE_DELETE_WORKFLOWTASK = 'wagtailcore.delete_workflowtask',
  WAGTAILCORE_VIEW_WORKFLOWTASK = 'wagtailcore.view_workflowtask',
  WAGTAILCORE_ADD_TASK = 'wagtailcore.add_task',
  WAGTAILCORE_CHANGE_TASK = 'wagtailcore.change_task',
  WAGTAILCORE_DELETE_TASK = 'wagtailcore.delete_task',
  WAGTAILCORE_VIEW_TASK = 'wagtailcore.view_task',
  WAGTAILCORE_ADD_WORKFLOWSTATE = 'wagtailcore.add_workflowstate',
  WAGTAILCORE_CHANGE_WORKFLOWSTATE = 'wagtailcore.change_workflowstate',
  WAGTAILCORE_DELETE_WORKFLOWSTATE = 'wagtailcore.delete_workflowstate',
  WAGTAILCORE_VIEW_WORKFLOWSTATE = 'wagtailcore.view_workflowstate',
  WAGTAILCORE_ADD_TASKSTATE = 'wagtailcore.add_taskstate',
  WAGTAILCORE_CHANGE_TASKSTATE = 'wagtailcore.change_taskstate',
  WAGTAILCORE_DELETE_TASKSTATE = 'wagtailcore.delete_taskstate',
  WAGTAILCORE_VIEW_TASKSTATE = 'wagtailcore.view_taskstate',
  WAGTAILCORE_ADD_GROUPAPPROVALTASK = 'wagtailcore.add_groupapprovaltask',
  WAGTAILCORE_CHANGE_GROUPAPPROVALTASK = 'wagtailcore.change_groupapprovaltask',
  WAGTAILCORE_DELETE_GROUPAPPROVALTASK = 'wagtailcore.delete_groupapprovaltask',
  WAGTAILCORE_VIEW_GROUPAPPROVALTASK = 'wagtailcore.view_groupapprovaltask',

  // --- WAGTAIL DOCS / IMAGES / MEDIA ---
  WAGTAILDOCS_ADD_DOCUMENT = 'wagtaildocs.add_document',
  WAGTAILDOCS_CHANGE_DOCUMENT = 'wagtaildocs.change_document',
  WAGTAILDOCS_DELETE_DOCUMENT = 'wagtaildocs.delete_document',
  WAGTAILDOCS_CHOOSE_DOCUMENT = 'wagtaildocs.choose_document',
  WAGTAILDOCS_VIEW_DOCUMENT = 'wagtaildocs.view_document',
  WAGTAILDOCS_ADD_UPLOADEDFILE = 'wagtaildocs.add_uploadedfile',
  WAGTAILDOCS_CHANGE_UPLOADEDFILE = 'wagtaildocs.change_uploadedfile',
  WAGTAILDOCS_DELETE_UPLOADEDFILE = 'wagtaildocs.delete_uploadedfile',
  WAGTAILDOCS_VIEW_UPLOADEDFILE = 'wagtaildocs.view_uploadedfile',
  WAGTAILIMAGES_ADD_IMAGE = 'wagtailimages.add_image',
  WAGTAILIMAGES_CHANGE_IMAGE = 'wagtailimages.change_image',
  WAGTAILIMAGES_DELETE_IMAGE = 'wagtailimages.delete_image',
  WAGTAILIMAGES_CHOOSE_IMAGE = 'wagtailimages.choose_image',
  WAGTAILIMAGES_VIEW_IMAGE = 'wagtailimages.view_image',
  WAGTAILIMAGES_ADD_RENDITION = 'wagtailimages.add_rendition',
  WAGTAILIMAGES_CHANGE_RENDITION = 'wagtailimages.change_rendition',
  WAGTAILIMAGES_DELETE_RENDITION = 'wagtailimages.delete_rendition',
  WAGTAILIMAGES_VIEW_RENDITION = 'wagtailimages.view_rendition',

  // --- WAGTAIL USERS ---
  WAGTAILUSERS_ADD_USER = 'wagtailusers.add_user',
  WAGTAILUSERS_CHANGE_USER = 'wagtailusers.change_user',
  WAGTAILUSERS_DELETE_USER = 'wagtailusers.delete_user',
  WAGTAILUSERS_ADD_USERPROFILE = 'wagtailusers.add_userprofile',
  WAGTAILUSERS_CHANGE_USERPROFILE = 'wagtailusers.change_userprofile',
  WAGTAILUSERS_DELETE_USERPROFILE = 'wagtailusers.delete_userprofile',
  WAGTAILUSERS_VIEW_USERPROFILE = 'wagtailusers.view_userprofile',

  // --- WAGTAIL FORMS / REDIRECTS / EMBEDS / SEARCH ---
  WAGTAILFORMS_ADD_FORMSUBMISSION = 'wagtailforms.add_formsubmission',
  WAGTAILFORMS_CHANGE_FORMSUBMISSION = 'wagtailforms.change_formsubmission',
  WAGTAILFORMS_DELETE_FORMSUBMISSION = 'wagtailforms.delete_formsubmission',
  WAGTAILFORMS_VIEW_FORMSUBMISSION = 'wagtailforms.view_formsubmission',
  WAGTAILREDIRECTS_ADD_REDIRECT = 'wagtailredirects.add_redirect',
  WAGTAILREDIRECTS_CHANGE_REDIRECT = 'wagtailredirects.change_redirect',
  WAGTAILREDIRECTS_DELETE_REDIRECT = 'wagtailredirects.delete_redirect',
  WAGTAILREDIRECTS_VIEW_REDIRECT = 'wagtailredirects.view_redirect',
  WAGTAILEMBEDS_ADD_EMBED = 'wagtailembeds.add_embed',
  WAGTAILEMBEDS_CHANGE_EMBED = 'wagtailembeds.change_embed',
  WAGTAILEMBEDS_DELETE_EMBED = 'wagtailembeds.delete_embed',
  WAGTAILEMBEDS_VIEW_EMBED = 'wagtailembeds.view_embed',
  WAGTAILSEARCH_ADD_INDEXENTRY = 'wagtailsearch.add_indexentry',
  WAGTAILSEARCH_CHANGE_INDEXENTRY = 'wagtailsearch.change_indexentry',
  WAGTAILSEARCH_DELETE_INDEXENTRY = 'wagtailsearch.delete_indexentry',
  WAGTAILSEARCH_VIEW_INDEXENTRY = 'wagtailsearch.view_indexentry',
  WAGTAILSEARCH_ADD_SQLITEFTSINDEXENTRY = 'wagtailsearch.add_sqliteftsindexentry',
  WAGTAILSEARCH_CHANGE_SQLITEFTSINDEXENTRY = 'wagtailsearch.change_sqliteftsindexentry',
  WAGTAILSEARCH_DELETE_SQLITEFTSINDEXENTRY = 'wagtailsearch.delete_sqliteftsindexentry',
  WAGTAILSEARCH_VIEW_SQLITEFTSINDEXENTRY = 'wagtailsearch.view_sqliteftsindexentry',
  WAGTAILSEARCH_ADD_EDITINGSESSION = 'wagtailsearch.add_editingsession',
  WAGTAILSEARCH_CHANGE_EDITINGSESSION = 'wagtailsearch.change_editingsession',
  WAGTAILSEARCH_DELETE_EDITINGSESSION = 'wagtailsearch.delete_editingsession',
  WAGTAILSEARCH_VIEW_EDITINGSESSION = 'wagtailsearch.view_editingsession',

  // --- TAGGIT ---
  TAGGIT_ADD_TAG = 'taggit.add_tag',
  TAGGIT_CHANGE_TAG = 'taggit.change_tag',
  TAGGIT_DELETE_TAG = 'taggit.delete_tag',
  TAGGIT_VIEW_TAG = 'taggit.view_tag',
  TAGGIT_ADD_TAGGEDITEM = 'taggit.add_taggeditem',
  TAGGIT_CHANGE_TAGGEDITEM = 'taggit.change_taggeditem',
  TAGGIT_DELETE_TAGGEDITEM = 'taggit.delete_taggeditem',
  TAGGIT_VIEW_TAGGEDITEM = 'taggit.view_taggeditem',
}

type PermissionGroups = {
  [key: string]: {
    [subcategory: string]: string[];
  };
};

export function getGroupedPermissions(): PermissionGroups {
  const groupedPermissions: PermissionGroups = {};
  const skippedCategories = [
    'account',
    'admin',
    'sessions',
    'sites',
    'contenttypes',
    'otp_static',
    'otp_totp',
    'socialaccount',
    'taggit',
  ];
  const skippedSubcategories = ['permission'];

  const skippedSpecificPermissions = [
    USER_PERMISSIONS.WAGTAILCORE_ADD_PAGE,
    USER_PERMISSIONS.WAGTAILCORE_CHANGE_PAGE,
    USER_PERMISSIONS.WAGTAILCORE_DELETE_PAGE,
    USER_PERMISSIONS.WAGTAILCORE_PUBLISH_PAGE,
    USER_PERMISSIONS.WAGTAILCORE_LOCK_PAGE,
    USER_PERMISSIONS.WAGTAILCORE_UNLOCK_PAGE,
    USER_PERMISSIONS.WAGTAILCORE_BULK_DELETE_PAGE,
  ];

  Object.values(USER_PERMISSIONS).forEach((permission) => {
    if (skippedSpecificPermissions.includes(permission)) {
      return;
    }

    let [category] = permission.split('.');
    const [, subcategory] = permission.split('_');

    if (skippedCategories.includes(category)) {
      return;
    }

    if (skippedSubcategories.includes(subcategory)) {
      return;
    }

    if (category.startsWith('wagtail')) {
      category = 'wagtail';
    }

    if (!groupedPermissions[category]) {
      groupedPermissions[category] = {};
    }

    if (!groupedPermissions[category][subcategory]) {
      groupedPermissions[category][subcategory] = [];
    }

    groupedPermissions[category][subcategory].push(permission);
  });

  return groupedPermissions;
}
